import {rpcCall} from "../../util/rpc/rpcCalls"
import {
    EditingUserDisabled,
    NoAccessToScopeError,
    NoEditHierarchyRightError,
    NoManageUsersRightError,
    NoRightsError,
    NoSubmitTTRightError,
    NoSuchUserError,
    NotAssignedError,
    NotFoundError
} from "../errors"

export default class ProjectInfoService {
    getAssignedUsers(projectId) {
        return rpcCall("ProjectInfoService.getAssignedUsers", [projectId], this._rpcErrorHandler)
    }

    updateAssignedUsers(projectId, addedUserIds, removeUserIds) {
        return rpcCall("ProjectInfoService.updateAssignedUsers", [projectId, addedUserIds, removeUserIds], this._rpcErrorHandler)
    }

    updateManagers(projectId, addedUserIds, removeUserIds) {
        return rpcCall("ProjectInfoService.updateManagers", [projectId, addedUserIds, removeUserIds], this._rpcErrorHandler)
    }

    _rpcErrorHandler(rpcError) {
        rpcError.handleOnException('com.actimind.actitime.project.NoSuchProjectException', new NotFoundError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsForRemoteCallException', new NoRightsError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightToEditHierarchyException', new NoEditHierarchyRightError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new NoManageUsersRightError());
        rpcError.handleOnException('com.actimind.actitime.services.UserIsNotAssignedToManagerException', new NotAssignedError())
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToSubmitTTException', new NoSubmitTTRightError())
        rpcError.handleOnException('com.actimind.actitime.services.UserHasNoAccessToScopeException', new NoAccessToScopeError())
        rpcError.handleOnException('com.actimind.actitime.administration.NoSuchUserException', new NoSuchUserError())
        rpcError.handleOnException('com.actimind.actitime.administration.UserIsDisabledException', new EditingUserDisabled())
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/rpc/ProjectInfoService.js